import { useContext } from 'react';
import { useQuery } from 'react-query';
import { SettingsContext } from '../store/SettingsContext';
import { UserContext } from '../store/UserContext';
import useAxios from './useAxios';
import useSubscriber from './useSubscriber';

export interface OnlyFansMeAvatarThumbs {
    c50: string;
    c144: string;
}

export interface OnlyFansMeHeaderSize {
    width: number;
    height: number;
}

export interface OnlyFansMeHeaderThumbs {
    w480: string;
    w760: string;
}

export interface OnlyFansMeSubscriptionBundlesEntity {
    id: number;
    discount: number;
    duration: number;
    price: number;
    canBuy: boolean;
}

export interface OnlyFansMePromotionsEntity {
    id: number;
    message: string;
    rawMessage: string;
    hasRelatedPromo: boolean;
    price: number;
    type: string;
    canClaim: boolean;
    claimsCount: number;
    subscribeCounts?: null;
    subscribeDays: number;
    createdAt: string;
    finishedAt?: string | null;
}

export interface OnlyFansMeHasNewTicketReplies {
    open: boolean;
    solved: boolean;
    closed: boolean;
}

export interface OnlyFansMeDiscounts {
    0: string;
    5: string;
    10: string;
    15: string;
    20: string;
    25: string;
    30: string;
    35: string;
    40: string;
    45: string;
    50: string;
}

export interface OnlyFansMeDurations {
    3: string;
    6: string;
    12: string;
}

export interface OnlyFansMeCanAddSubscriberByBundle {
    discounts: OnlyFansMeDiscounts;
    durations: OnlyFansMeDurations;
}

export interface OnlyFansMeConnectedOfAccountsEntity {
    view: string;
    id: number;
    name: string;
    username: string;
    avatar: string;
    avatarThumbs: OnlyFansMeAvatarThumbs;
}

export interface OnlyFansMeAvatarThumbs {
    c50: string;
    c144: string;
}
export interface OnlyFansMeConnectedOfAccountsEntity {
    view: string;
    id: number;
    name: string;
    username: string;
    avatar: string;
    avatarThumbs: OnlyFansMeAvatarThumbs;
}

export interface SubscribedDataSubscribe {
    id: number;
    userId: number;
    subscriberId: number;
    date: Date;
    duration: number;
    startDate: Date;
    expireDate: Date;
    cancelDate?: Date;
    price: number;
    regularPrice: number;
    discount: number;
    earningId: number;
    action: string;
    type: string;
    offerStart?: Date;
    offerEnd?: Date;
    isCurrent: boolean;
}

export interface SubscribedOnData {
    price: number;
    newPrice: number;
    regularPrice: number;
    subscribePrice: number;
    discountPercent: number;
    discountPeriod: number;
    subscribeAt: Date;
    expiredAt: Date;
    renewedAt?: Date;
    discountFinishedAt?: Date;
    discountStartedAt?: Date;
    status?: string;
    isMuted: boolean;
    unsubscribeReason: string;
    duration: string;
    messagesSumm: number;
    tipsSumm: number;
    subscribesSumm: number;
    postsSumm: number;
    streamsSumm: number;
    totalSumm: number;
    subscribes: SubscribedDataSubscribe[];
}

export interface OnlyFansMe {
    view: string;
    avatar: string;
    avatarThumbs: OnlyFansMeAvatarThumbs;
    header: string;
    headerSize: OnlyFansMeHeaderSize;
    headerThumbs: OnlyFansMeHeaderThumbs;
    id: number;
    name: string;
    username: string;
    canLookStory: boolean;
    canCommentStory: boolean;
    hasNotViewedStory: boolean;
    isVerified: boolean;
    canPayInternal: boolean;
    hasScheduledStream: boolean;
    hasStream: boolean;
    hasStories: boolean;
    tipsEnabled: boolean;
    tipsTextEnabled: boolean;
    tipsMin: number;
    tipsMax: number;
    canEarn: boolean;
    canAddSubscriber: boolean;
    subscribePrice: number;
    hasStripe: boolean;
    isStripeExist: boolean;
    subscriptionBundles?: OnlyFansMeSubscriptionBundlesEntity[] | null;
    canSendChatToAll: boolean;
    creditsMin: number;
    creditsMax: number;
    isPaywallRestriction: boolean;
    unprofitable: boolean;
    listsSort: string;
    listsSortOrder: string;
    canCreateLists: boolean;
    joinDate: string;
    isReferrerAllowed: boolean;
    about: string;
    rawAbout: string;
    website: string;
    wishlist: string;
    location: string;
    postsCount: number;
    archivedPostsCount: number;
    photosCount: number;
    videosCount: number;
    audiosCount: number;
    mediasCount: number;
    lastSeen: string;
    favoritesCount: number;
    favoritedCount: number;
    showPostsInFeed: boolean;
    canReceiveChatMessage: boolean;
    isPerformer: boolean;
    isRealPerformer: boolean;
    isSpotifyConnected: boolean;
    subscribersCount: number;
    hasPinnedPosts: boolean;
    canChat: boolean;
    callPrice: number;
    isPrivateRestriction: boolean;
    showSubscribersCount: boolean;
    showMediaCount: boolean;
    subscribedByData?: null;
    subscribedOnData?: SubscribedOnData;
    canPromotion: boolean;
    canCreatePromotion: boolean;
    canCreateTrial: boolean;
    isAdultContent: boolean;
    canTrialSend: boolean;
    hasFriends: boolean;
    hasLinks: boolean;
    promotions?: OnlyFansMePromotionsEntity[] | null;
    canAddPhone: boolean;
    phoneLast4?: null;
    phoneMask?: null;
    hasNewTicketReplies: OnlyFansMeHasNewTicketReplies;
    hasInternalPayments: boolean;
    isCreditsEnabled: boolean;
    creditBalance: number;
    isMakePayment: boolean;
    isAgeVerified: boolean;
    ageVerificationRequired: boolean;
    isOtpEnabled: boolean;
    email: string;
    isEmailChecked: boolean;
    isLegalApprovedAllowed: boolean;
    isTwitterConnected: boolean;
    twitterUsername: string;
    isAllowTweets: boolean;
    isPaymentCardConnected: boolean;
    referalUrl: string;
    isVisibleOnline: boolean;
    subscribesCount: number;
    canPinPost: boolean;
    hasNewAlerts: boolean;
    hasNewHints: boolean;
    hasNewChangedPriceSubscriptions: boolean;
    notificationsCount: number;
    chatMessagesCount: number;
    isWantComments: boolean;
    watermarkText: string;
    customWatermarkText: string;
    hasWatermarkPhoto: boolean;
    hasWatermarkVideo: boolean;
    canDelete: boolean;
    isTelegramConnected: boolean;
    advBlock?: string[] | null;
    hasPurchasedPosts: boolean;
    isEmailRequired: boolean;
    isPayoutLegalApproved: boolean;
    payoutLegalApproveState: string;
    payoutLegalApproveRejectReason: string;
    enabledImageEditorForChat: boolean;
    shouldReceiveLessNotifications: boolean;
    canCalling: boolean;
    paidFeed: boolean;
    canSendSms: boolean;
    canAddFriends: boolean;
    isRealCardConnected: boolean;
    countPriorityChat: number;
    hasScenario: boolean;
    isWalletAutorecharge: boolean;
    walletAutorechargeAmount: number;
    walletAutorechargeMin: number;
    walletFirstRebills: boolean;
    closeFriends: number;
    canAlternativeWalletTopUp: boolean;
    needIVApprove: boolean;
    ivStatus: string;
    ivFailReason?: null;
    canCheckDocsOnAddCard: boolean;
    faceIdAvailable: boolean;
    ivCountry: string;
    ivForcedVerified: boolean;
    ivFlow: string;
    isVerifiedReason: boolean;
    canReceiveManualPayout: boolean;
    canReceiveStripePayout: boolean;
    manualPayoutPendingDays: number;
    isNeedConfirmPayout: boolean;
    canStreaming: boolean;
    isScheduledStreamsAllowed: boolean;
    canMakeExpirePosts: boolean;
    trialMaxDays: number;
    trialMaxExpiresDays: number;
    messageMinPrice: number;
    messageMaxPrice: number;
    postMinPrice: number;
    postMaxPrice: number;
    streamMinPrice: number;
    streamMaxPrice: number;
    canCreatePaidStream: boolean;
    callMinPrice: number;
    callMaxPrice: number;
    subscribeMinPrice: number;
    subscribeMaxPrice: number;
    bundleMaxPrice: number;
    unclaimedOffersCount: number;
    claimedOffersCount: number;
    withdrawalPeriod: string;
    canAddStory: boolean;
    canAddSubscriberByBundle: OnlyFansMeCanAddSubscriberByBundle;
    isSuggestionsOptOut: boolean;
    canCreateFundRaising: boolean;
    minFundRaisingTarget: number;
    maxFundRaisingTarget: number;
    disputesRatio: number;
    vaultListsSort: string;
    vaultListsSortOrder: string;
    canCreateVaultLists: boolean;
    canMakeProfileLinks: boolean;
    ivHideForPerformers: boolean;
    performerTop: number;
    replyOnSubscribe: boolean;
    form1099: string;
    payoutType: string;
    minPayoutSumm: number;
    canHasW9Form: boolean;
    isVatRequired: boolean;
    isCountryVatRefundable: boolean;
    isCountryVatNumberCollect: boolean;
    vatNumberName: string;
    isCountryWithVat: boolean;
    connectedOfAccounts?: OnlyFansMeConnectedOfAccountsEntity[] | null;
    hasPassword: boolean;
    canConnectOfAccount: boolean;
    cantConnectOfAccountReason: string;
    pinnedPostsCount: number;
    maxPinnedPostsCount: number;
    wsAuthToken: string;
    wsUrl: string;
}

const useSubscriberMe = () => {
    const userContext = useContext(UserContext);
    const settingsContext = useContext(SettingsContext);
    const { data: subscriber } = useSubscriber();
    const axios = useAxios();

    const fetchData = async (): Promise<{ me: OnlyFansMe | null; isLoggedIn: boolean }> => {
        if (!userContext.jwtToken || !settingsContext.apiKey || !subscriber?._id) {
            return { me: null, isLoggedIn: false };
        }

        const query: string = `${settingsContext.routes.onlyFans.base}${subscriber._id}/me`;

        return axios
            .get(query)
            .then(response => response.data)
            .catch(() => {
                return { me: null, isLoggedIn: false };
            });
    };

    const subscriberMe = useQuery(['subscriberMe', subscriber?._id], () => fetchData(), {
        refetchOnWindowFocus: false,
        retry: false,
        // Never fetch on mount; callers must use refetch() (e.g. "Copy from OnlyFans").
        enabled: false,
    });

    return { ...subscriberMe };
};

export default useSubscriberMe;
